type PossibleValue = string | number | boolean | undefined

export type Params = {
  [key: string]: PossibleValue
}

const objectToQueryString = (params: Params): string => {
  const filterUndefined = Object.entries(params).filter(
    ([, value]) => value !== undefined
  )

  const queryString = filterUndefined
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(
          value as string | number | boolean
        )}`
    )
    .join('&')
  return queryString
}

export default objectToQueryString
